/** @license @dairyfarm/eval-web v3.0.0
* Copyright 2020 Texas A&M Center for Applied Technology, 
* Texas A&M Engineering Experiment Station, The Texas A&M 
* University System.
* 
* This source code/schema and any derivative work is Texas 
* A&M Engineering Experiment Station intellectual property 
* and protected by copyright law. Usage is restricted solely 
* to the FARM Animal Care and Environmental Stewardship 
* programs administered by the National Milk Producers 
* Federation. Dissemination of this source code and/or 
* derivative work creation is strictly prohibited without 
* express written permission from the Texas A&M Engineering 
* Experiment Station.
*/
import { IconButton, InputAdornment, InputBase, Theme } from "@material-ui/core";
import ClearIcon from "@material-ui/icons/Cancel";
import SearchIcon from "@material-ui/icons/Search";
import { createStyles, makeStyles } from "@material-ui/styles";
import React, { ChangeEvent, useMemo, useState } from "react";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: theme.palette.primary.light,
      padding: theme.spacing(1),
      display: "flex",
      borderRadius: theme.shape.borderRadius,
      color: "inherit",
      alignItems: "center",
      justifyContent: "space-between",
    },
    searchRoot: {
      width: "100%",
      color: "inherit",
    },
    searchIcon: {
      marginRight: theme.spacing(2),
    },
    searchInput: {
      color: "inherit",
      width: "100%",
    },
  })
);

interface SearchProps {
  onSearchUpdated: (text: string) => void;
  className?: string;
  showClear?: boolean;
}

export default (props: SearchProps) => {
  const classes = useStyles(props);

  const [text, setText] = useState<string>("");
  const clearDisabled = useMemo(() => text === "", [text]);

  return (
    <div className={classes.root.concat(props.className ? ` ${props.className}` : "")}>
      <SearchIcon className={classes.searchIcon} />
      <InputBase
        placeholder="Search"
        classes={{
          root: classes.searchRoot,
          input: classes.searchInput,
        }}
        onChange={(event: ChangeEvent<HTMLInputElement>) => {
          const newText = event.target.value;
          setText(newText);
          props.onSearchUpdated(newText);
        }}
        value={text}
        autoFocus
        endAdornment={
          <InputAdornment position="end">
            {props.showClear && (
              <IconButton
                color="inherit"
                onClick={() => {
                  setText("");
                  props.onSearchUpdated("");
                }}
                disabled={clearDisabled}
              >
                <ClearIcon />
              </IconButton>
            )}
          </InputAdornment>
        }
      />
    </div>
  );
};
